import request from '@/utils/request'
// 购物车列表
export function fetchList(params) {
  return request({
    url:'Shop.Cart/getList',
    method:'get',
    params:params
  })
}
// 加入购物车
export function addShoppingCart(params) {
  return request({
    url:'Shop.Cart/add',
    method:'post',
    params:params
  })
}
// 删除购物车
export function delShoppingCart(params) {
  return request({
    url:'Shop.Cart/delete',
    method:'post',
    data:params
  })
}
// 修改客户销售价格
export function editSalePrice(params) {
  return request({
    url:'Shop.Cart/editSalePrice',
    method:'post',
    data:params
  })
}
// 清空购物车
export function deleteAll(params) {
  return request({
    url:'Shop.Cart/deleteAll',
    method:'get',
    params:params
  })
}
// 一键收藏
export function batchSubscription(params) {
  return request({
    url:'Shop.Product/batch_subscribe',
    method:'post',
    data:params
  })
}
// 提交订单
export function submitOrder(params) {
  return request({
    url:'Shop.Order/add',
    method:'post',
    data:params
  })
}
// 提交销售订单
export function addSale(data) {
  return request({
    url:'Shop.SaleOrder/add',
    method:'post',
    data:data
  })
}

// 搜索客户地址
export function searchCustomer(params) {
  return request({
    url:'Shop.OrderCustomer/list',
    method:'get',
    params:params
  })
}

// // 客户地址
// export function getCustomer(params) {
//   return request({
//     url:'Shop.OrderCustomer/getCartCustomer',
//     method:'get',
//     data:params
//   })
// }

// 客户详情
export function customerDeatil(params) {
  return request({
    url:'Shop.OrderCustomer/getDetail?',
    method:'get',
    params:params
  })
}

// 添加备注
export function addRemarks(params) {
  return request({
    url:'Shop.Cart/addRemarks',
    method:'post',
    data:params
  })
}

// 获取订单详情
export function getDetail(params) {
  return request({
    url:'Shop.Order/getDetail',
    method:'get',
    data:params
  })
}
// 获取物流详情
export function getLogistics(params) {
  return request({
    url:'Shop.Order/getLogistics',
    method:'get',
    data:params
  })
}
// 获取子账号
export function getSubUser() {
  return request({
    url:'Shop.Cart/getSubUser',
    method:'get',
  })
}

// 修改报价加价率
export function quoteUpdate(params) {
  return request({
    url:'/Shop.User/update',
    method:'post',
    data:params
  })
}



// WEBPACK FOOTER //
// ./src/api/shoppingCart.js